<template>
    <div>

            <div v-for="(mod,i) in listModules" :key="i">
                <div v-if="!mod.module.dialog">
                <v-btn icon primary @click="close(i)" x-small><v-icon>mdi-close-thick</v-icon></v-btn>
                    <component
                    :key="key"  
                    v-bind:is="$modules[mod.module.type].components.client"
                    :idmodule="mod.module.id" 
                    :modal="modal"
                    :page="page"
                    :modalKey="modalKey"
                    :form="form"
                    :customparams="mod.params"
                    :customquerys="mod.querys"
                    :hook="hook"
                    ></component>
                </div>

                <div v-if="mod.module.dialog">
                    <v-dialog
                    v-model="dialog"
                    :fullscreen="($vuetify.breakpoint.xs) ? true : false"
                    @click:outside="close(i)"
                    >
                    

                    <v-card>
                        <v-card-title class="grey lighten-2">
                        <v-btn icon @click="close(i)"><v-icon>mdi-close-thick</v-icon></v-btn>      
                        </v-card-title>

                        <v-card-text>
                            <component
                            :key="key"  
                            v-bind:is="$modules[mod.module.type].components.client"
                            :idmodule="mod.module.id" 
                            :modal="modal"
                            :page="page"
                            :modalKey="modalKey"
                            :form="form"
                            :customparams="mod.params"
                            :customquerys="mod.querys"
                            :hook="hook"
                            ></component>
                        </v-card-text>


                    </v-card>
                    </v-dialog>        
                </div>            
            </div>

            <!-- Pour l'ouverture de la modal avec les actions demandés par les ventilations pour l'utilisateur-->
            <v-dialog 
            v-model="dialogVentilation" 
            persistent
            max-width="1000px">
                    

                    <v-card>
                        <v-card-title class="app-theme-bg-modal-header">
                        {{titleVentil}}
                        </v-card-title>
                        <v-card-text>

                            <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation>

                            <CPage 
                            v-if="dialogVentilation"
                            :pageTemplate="templateVentil" 
                            :page="page" 
                            :modal="modal" 
                            :form="form" 
                            hook="ventilation"
                            :mod="false"
                            @sendDatas="getAction"
                            :datasSend="collectActions"
                            />

                            <v-row>
                                <v-col class="text-center">
                                    <v-btn @click="closeVentil" :disabled="!valid">Valider</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                        </v-card-text>


                    </v-card>
            </v-dialog> 


            <!-- pour l'affichage de page-->
             <div v-for="(page,i) in listPages" :key="i">
                <main-component 
                :page="page.page" 
                :hook="hook" 
                :customparams="page.params"
                :typeform="page.type"
                :modal="modal"
                ></main-component>

             </div>


    </div>
    </template>
    
    
    
    <script>
import OverLay from '@/components/outils/overlay.vue'
import { EventBus } from '@/services/EventBus';
import { client } from '../mixins';
        export default {

        props: ['crochet'],
        mixins : [client],
        name : 'VentilMod',
        components : {
          OverLay,
        },

            data: function() {
    
                return {

                    listModules : [],
                    listPages : [],
                    paramsModule : {params:{},querys:{},module:{}},
                    params:{},
                    key : 0,
                    querys:{},
                    dialog : true,
                    module : {id:'',type:'',dialog:false},
                    dialogVentilation : false,
                    messageDemand : '',
                    templateVentil : [],
                    titleVentil : '',
                    actionsDemand : [],
                    reloadAction : 0,
                    collectActions : {},
                    valid : true

                }
                
            },

        computed : {
            getVentilation() {
                return this.$store.getters['getVentilation']
            }
        },

        watch : {

            getVentilation(val) {
                val.forEach((ventil) => {
                    //le IUPD concerne les enregistrement à la volé sur les tableau
                    if((ventil.crochet == this.crochet && this.modalKey == ventil.page.replace('IUPD_', '') ) 
                    || 
                    (!this.crochet && ventil.crochet=='' && this.modalKey == ventil.page.replace('IUPD_', '') )
                    ) {
                        
                        var newParams = JSON.parse(JSON.stringify(this.paramsModule));
                        
                        switch(ventil.type) {
                        
                            case 'loadmodule' :
                            ventil.datas.forEach((data) => {
                                switch(data.typevar) {
                                    case 'params' : 
                                    newParams.params[data.key] = data.value 
                                    break;
                                    case 'query' : 
                                    newParams.querys[data.key] = data.value 
                                    break;
                                }
                                
                            })
                        newParams.module = ventil.module
                        this.listModules.push(newParams);
                        this.$store.dispatch('removeVentilation',ventil)

                        break;

                        case 'loadpage' :
                            var replace = {params:{},querys:{}}
                        ventil.datas.forEach((data) => {
                            switch(data.typevar) {
                                case 'params' : 
                                replace.params[data.key] = data.value 
                                break;
                                case 'query' : 
                                replace.querys[data.key] = data.value 
                                break;
                            }
                            
                        })
                        var defPage = this.definePage(ventil.pageloaded)
                        newParams.page = defPage.page
                        newParams.type = defPage.typeform 
                        newParams.params = replace.params;
                        console.log(newParams)
                        if(ventil.modeopen=='crochet') this.listPages.push(newParams);
                        if(ventil.modeopen=='modal') {
                            this.goTo({
                            modalKey: this.modalKey,
                            name: ventil.pageloaded,
                            type: 'modal',
                            replace: replace.params,
                            });                            
                        }
                        this.$store.dispatch('removeVentilation',ventil)

                        break;                        
                    }


                    }

                })
            }



        },

            methods :  {    

                getAction(data) {
                    this.$set(this.collectActions, data.key, data.value);
                },

                handleSendDatas(data) {
                    if((data.crochet == this.crochet && this.modalKey == data.page.replace('IUPD_', ''))
                    ||
                    (!this.crochet && data.crochet=='' && this.modalKey == data.page.replace('IUPD_', ''))) {
                        this.actionsDemand = data.actions;
                        this.messageDemand = data.message
                        this.templateVentil = data.template;
                        this.titleVentil = data.title;
                        this.dialogVentilation = true;
                        this.reloadAction++;
                    }
                },
   

                initiateParams() {
                    this.params = this.$store.getters.specificPage(this.modalKey).params    
                    this.querys = this.$store.getters.specificPage(this.modalKey).querys
                },

                close(i) {
                    this.listModules = this.listModules.filter((el,u) => u!=i)
                },

                closeVentil() {
                    this.dialogVentilation = false;  
                    EventBus.$emit('send-data',this.collectActions);  
                                   
                },
                
            definePage(page) {
                //permet de définir si cette page est un form, dans ce cas, obligatoirement en mode edit, sinon page simple
                    let type = this.newurl({name:page,replace:{},returnElement:'all'});
                    return type.props


            }

            },
            mounted() {
                this.initiateParams()
            },
    
            created() {  
                EventBus.$on('sendDatas', this.handleSendDatas);
            },

            beforeDestroy() {
                EventBus.$off('sendDatas', this.handleSendDatas);
            }
    
        }
    
    </script>
